import { Trans } from '@lingui/macro';
import { Fragment, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Tooltip,
  Link,
} from '@mui/material';
import { Warning } from '@mui/icons-material';

interface Props {
  tickets: {
    id: string
    name: string
    description: string
  }[] | null
}

const OdooTicketPreview = ({ tickets }: Props) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const parseDescription = (desc: string) => {
    const cleanDesc = desc.replace(/<[^>]*>/g, '').trim();
    return cleanDesc.split('----------').map((part) => part.trim());
  };

  return (
    <>
      {tickets === null ? (
        <Tooltip title={<Trans>Error al conectarse a tickets de Odoo</Trans>}>
          <Button color="warning">
            <Trans>Odoo</Trans> (<Warning fontSize="small"  />)
          </Button>
        </Tooltip>
      ) : (
        <Button onClick={handleClickOpen}>
          <Trans>Odoo</Trans> (<b>{tickets.length}</b>)
        </Button>
      )}

      {tickets !== null && (
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="md"
          fullWidth
          aria-labelledby="odoo-ticket-dialog-title"
        >
          <DialogTitle id="odoo-ticket-dialog-title">
            Odoo Tickets
          </DialogTitle>
          <DialogContent dividers>
          {tickets.length === 0 ? (
            <Typography>No existen tickets disponibles.</Typography>
          ) : (
            <List
              sx={{
                width: '100%',
                bgcolor: 'background.paper',
                position: 'relative',
                overflow: 'auto',
                maxHeight: 300,
                '& ul': { padding: 0 },
              }}
            >
              {tickets.map((ticket, index) => (
                <Fragment key={ticket.id}>
                  {index > 0 && <Divider />}
                  <ListItem alignItems="flex-start">
                    <ListItemText
                      primary={
                        <Typography component="div">
                          <Link
                            href={`https://odoo.captahydro.com/web#id=${ticket.id}&model=helpdesk.ticket&view_type=form`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Ticket ID: {ticket.id}
                          </Link>
                          {' '}- {ticket.name}
                        </Typography>
                      }
                      secondary={
                        <div>
                          {parseDescription(ticket.description).map((line, idx) => (
                            <Typography key={idx} variant="body2" color="text.secondary">
                              {line}
                            </Typography>
                          ))}
                        </div>
                      }
                    />
                  </ListItem>
                </Fragment>
              ))}
            </List>
          )}
        </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default OdooTicketPreview;
